import { SaveListButton } from "components/entities/save_components/lists/SaveListButton";
import { useAllBuyersSaved } from "lib/hooks/api/buyer_lists/useAllBuyersSaved";
import { EventData } from "lib/tracking";

type Props = {
  buyerGuids: string[];
  trackingData?: EventData;
  /** Drops the "Save" label where the row is tight, such as a notice preview property row. */
  iconOnly?: boolean;
};

/**
 * Opens the save-to-list drawer for one or more buyers, and fills the bookmark once they are
 * saved, so the button shows the current state rather than only offering the action.
 */
export function SaveBuyerButton({ buyerGuids, trackingData, iconOnly }: Props) {
  const { allSaved, isLoading } = useAllBuyersSaved(buyerGuids);

  return (
    <SaveListButton
      entityIds={buyerGuids}
      entityType="buyer"
      trackingData={trackingData}
      buttonProps={{
        buttonType: "secondary",
        buttonText: iconOnly ? null : undefined,
        icon: {
          icon: "bookmark",
          // Secondary buttons already colour the icon sysPrimaryDefault, so filling with the
          // same token gives a solid blue bookmark rather than a two-tone one.
          fill: isLoading || !allSaved ? "transparent" : "sysPrimaryDefault",
        },
      }}
    />
  );
}

export default SaveBuyerButton;
